// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Ojs7","label":"CategoryService_label__33PRe","location":"CategoryService_location__3IyKV"};